import React, { useState } from "react";
import { Button } from "@amzn/awsui-components-react";
import { downloadFirstPassResults } from "../pdfUtils";

const DownloadResultsButton = ({ data, viewOption }) => {
  const [isDownloading, setIsDownloading] = useState(false);

  const handleDownload = async () => {
    if (!data) return;
    await downloadFirstPassResults(
      data,
      () => setIsDownloading(true),
      () => setIsDownloading(false),
      'rich',
      viewOption
    );
  }

  return (
    <Button
      iconName="download"
      variant="icon"
      onClick={handleDownload}
      disabled={isDownloading}
      loading={isDownloading}
    />
  );
};

export default DownloadResultsButton;
